import { render, staticRenderFns } from "./BanortePlayground.vue?vue&type=template&id=e0cf416a&scoped=true"
import script from "./BanortePlayground.vue?vue&type=script&setup=true&lang=ts"
export * from "./BanortePlayground.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BanortePlayground.vue?vue&type=style&index=0&id=e0cf416a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0cf416a",
  null
  
)

export default component.exports